import React, { useEffect, useState } from "react";
import {
  useJsApiLoader,
  GoogleMap,
  Marker,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { Skeleton } from "@mui/material";

const center = { lat: 11.0168, lng: 76.9558 };
const googleMapsLibraries = ["places"];

const LocationView = (props) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyBlP25Wo2XNTYJhB4JC-CJdobEx-eaNRug",
    libraries: googleMapsLibraries,
  });

  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [map, setMap] = useState(null);

  useEffect(() => {
    if (props.open && isLoaded) {
      LocationRoute(props.locationData);
    }
  }, [props.open, isLoaded]);

  async function LocationRoute(locationData) {
    if (!locationData?.from || !locationData?.to) return;

    const directionsService = new window.google.maps.DirectionsService();

    try {
      const result = await directionsService.route({
        origin: locationData.from,
        destination: locationData.to,
        travelMode: window.google.maps.TravelMode.DRIVING,
      });

      setDirectionsResponse(result);
    } catch (err) {
      console.error("Error fetching directions:", err);
    }
  }

  if (!isLoaded) {
    return <Skeleton variant="rectangular" height={600} />;
  }

  return (
    <GoogleMap
      center={center}
      zoom={15}
      mapContainerStyle={{ width: "100%", height: "600px" }}
      options={{
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
      }}
      onLoad={(map) => setMap(map)}
      onUnmount={() => setMap(null)}
    >
      {directionsResponse && (
        <>
          <Marker position={center} />
          <DirectionsRenderer directions={directionsResponse} />
        </>
      )}
    </GoogleMap>
  );
};

export default LocationView;
